"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralSummaryResponseDto = instanceOfReferralSummaryResponseDto;
exports.ReferralSummaryResponseDtoFromJSON = ReferralSummaryResponseDtoFromJSON;
exports.ReferralSummaryResponseDtoFromJSONTyped = ReferralSummaryResponseDtoFromJSONTyped;
exports.ReferralSummaryResponseDtoToJSON = ReferralSummaryResponseDtoToJSON;
exports.ReferralSummaryResponseDtoToJSONTyped = ReferralSummaryResponseDtoToJSONTyped;
var ReferralAsRefereeDto_1 = require("./ReferralAsRefereeDto");
var ReferralAsReferrerDto_1 = require("./ReferralAsReferrerDto");
var ReferralCreditsSummaryDto_1 = require("./ReferralCreditsSummaryDto");
/**
 * Check if a given object implements the ReferralSummaryResponseDto interface.
 */
function instanceOfReferralSummaryResponseDto(value) {
    if (!('my_code' in value) || value['my_code'] === undefined)
        return false;
    if (!('as_referrer' in value) || value['as_referrer'] === undefined)
        return false;
    if (!('as_referee' in value) || value['as_referee'] === undefined)
        return false;
    if (!('credits' in value) || value['credits'] === undefined)
        return false;
    return true;
}
function ReferralSummaryResponseDtoFromJSON(json) {
    return ReferralSummaryResponseDtoFromJSONTyped(json, false);
}
function ReferralSummaryResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'my_code': json['my_code'],
        'as_referrer': (0, ReferralAsReferrerDto_1.ReferralAsReferrerDtoFromJSON)(json['as_referrer']),
        'as_referee': (0, ReferralAsRefereeDto_1.ReferralAsRefereeDtoFromJSON)(json['as_referee']),
        'credits': (0, ReferralCreditsSummaryDto_1.ReferralCreditsSummaryDtoFromJSON)(json['credits']),
    };
}
function ReferralSummaryResponseDtoToJSON(json) {
    return ReferralSummaryResponseDtoToJSONTyped(json, false);
}
function ReferralSummaryResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'my_code': value['my_code'],
        'as_referrer': (0, ReferralAsReferrerDto_1.ReferralAsReferrerDtoToJSON)(value['as_referrer']),
        'as_referee': (0, ReferralAsRefereeDto_1.ReferralAsRefereeDtoToJSON)(value['as_referee']),
        'credits': (0, ReferralCreditsSummaryDto_1.ReferralCreditsSummaryDtoToJSON)(value['credits']),
    };
}
